import(/* webpackMode: "eager" */ "/var/app/staging/app/(with-metadata)/(main)/page.tsx");
